export const getImageBaseUrl = (masterImages, typeId: number) => {
    let imageBaseUrl;

    if (masterImages) {
        masterImages.map((image) => {
            if (image.masterTypeId === typeId) {
                imageBaseUrl = (!image.base64Image) ? image.base64Thumb : image.base64Image;
            }
        })
    }
    return imageBaseUrl;
}

export const updateImage = (masterImages, newImage, typeId) => {
    if (masterImages) {
        masterImages.map((image) => {
            if (image.masterTypeId === typeId) {
                image.base64Image = newImage;
            }
            return image;
        })
    }

    return masterImages;
}

export const addNewImage = (masterImages, newImage, typeId) => {
    const newMasterImages = masterImages ? masterImages : [];

    newMasterImages.push({
        base64Image: newImage,
        base64Thumb: '',
        id: 0,
        masterTypeId: typeId,
    });

    return newMasterImages;
}
